"use client";

import React from "react";
import { Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5155-scaled.jpg?v=9ve0txbj06i",
  alt: "Lüks kadife detaylı hasta koltuğu",
  className: "col-span-2 row-span-2"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2376.JPG-1-scaled-e1775587713408.jpeg?v=ya69xaoja6",
  alt: "Altın detaylı klinik armatürleri",
  className: "col-span-1 row-span-1"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2434.JPG-1-scaled-e1775587772636.jpeg?v=1yxv4rsis2y",
  alt: "Yüksek teknoloji 3D dental tarayıcı",
  className: "col-span-1 row-span-1"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2421.JPG-2-scaled.jpeg?v=p8zdiiygnw",
  alt: "Zarif ve konforlu bekleme salonu",
  className: "col-span-2 row-span-1"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2445.JPG-1-scaled-e1775587493160.jpeg?v=fq7gsidhta8",
  alt: "Lüks klinik iç mekan tasarımı",
  className: "col-span-1 row-span-1"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5666-scaled-e1776027694245.jpg?v=0r9ot82joss",
  alt: "İleri teknoloji dental ekipmanlar",
  className: "col-span-1 row-span-1"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/WhatsApp-Image-2026-04-11-at-11.17.53-1.jpeg?v=si61g4o8ux",
  alt: "Hasta konfor odaklı dinlenme alanı",
  className: "col-span-2 row-span-1"
}, {
  src: "https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_2443.JPG-1-scaled.jpeg?v=f9qjhguawrw",
  alt: "Modern sterilizasyon ve hijyen merkezi",
  className: "col-span-2 md:col-span-4 row-span-1"
}];
export default function KlinikKonforuVeTeknoloji() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="klinik-konforu-ve-teknoloji" className="dark bg-background text-foreground w-full overflow-hidden flex flex-col">
      {}
      <div className="container mx-auto px-4 py-20 md:py-32 flex flex-col items-center text-center">
        <div ref={headerRef} className={`max-w-3xl flex flex-col items-center transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="inline-flex items-center justify-center gap-2 px-3 py-1 mb-6 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium tracking-wide">
            <Sparkles className="size-4" />
            <span>Premium Deneyim</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium tracking-tight mb-6 text-foreground">Klinik&nbsp; Atmosferimiz</h2>
          <p className="text-lg md:text-xl text-muted-foreground font-light leading-relaxed max-w-2xl">
            Diş Hekimi Ayşegül İnneci Uzun kliniğinde, dünya standartlarında
            teknolojiyi, yüksek estetik anlayışı ve benzersiz bir hasta konforu
            ile harmanlıyoruz. Tedavi sürecinizin her anında lüksü ve güveni
            hissedin.
          </p>
        </div>
      </div>

      {}
      <div className="w-full h-[140vh] md:h-[170vh] grid grid-cols-2 md:grid-cols-4 grid-rows-4 gap-0">
        {galleryImages.map((image, index) => <div key={index} data-index={index} className={`relative overflow-hidden group ${image.className}`}>
            {}
            <div className="absolute inset-0 bg-background/10 group-hover:bg-transparent transition-colors duration-700 z-10 pointer-events-none" />
            
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" loading={index === 0 ? "eager" : "lazy"} />
            
            {}
            <div className="absolute inset-0 shadow-[inset_0_0_40px_rgba(0,0,0,0.3)] pointer-events-none z-20" />
          </div>)}
      </div>
    </section>;
}